import { useMutation, useQueryClient } from "@tanstack/react-query";
import useSnackbar from "../../../../hooks/useSnackbar";
import { SPECIES_MASTER } from "../../../../enums/QueryKeys";
import { speciesActivation } from "../../../../enums/queryFunction/Delete";

export default function useActivation(id) {
  const { handleSnackbar, SnackbarFeedback } = useSnackbar();
  const queryClient = useQueryClient();

  const activation = async (id) => {
    mutate(id);
  };

  const { mutate } = useMutation({
    mutationFn: speciesActivation,
    onSuccess: () => {
      queryClient.invalidateQueries([SPECIES_MASTER + id]);
      handleSnackbar("successMessage", "success");
    },
    onError: (error) => {
      handleSnackbar("errorMessage", "error");
    },
  });
  return {
    activation,
    SnackbarFeedback,
  };
}
